import { Input, Modal } from '@toggle/design-system';
import styled from 'styled-components';

export const StyledModalRoot = styled(Modal)`
  [data-modal-container] {
    width: 100%;
    min-width: 740px;
    max-width: 945px;
    background: var(--background-soft);
  }
`;

export const StyledInput = styled(Input)`
  [data-input-label] {
    color: var(--text-soft);
  }
`;

export const SpinnerWrapper = styled.div`
  display: flex;
  justify-content: center;
`;
